"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onRampApiKey = exports.bufferPercent = exports.HeaderNames = void 0;
var HeaderNames;
(function (HeaderNames) {
    HeaderNames["AuthToken"] = "x-auth-token";
    HeaderNames["AnalyticsToken"] = "x-analytics-token";
    HeaderNames["ProjectKey"] = "x-project-key";
    HeaderNames["ProjectMetadata"] = "x-project-metadata";
})(HeaderNames = exports.HeaderNames || (exports.HeaderNames = {}));
exports.bufferPercent = 13;
exports.onRampApiKey = 'pk_prod_01H66WYDRFM95JBTJ4VMGY1FAX';
